export type ActivesValuationAttributes = {
    value?: any;
    valuation?: any;
    score_position_rub?: any;
    sum_valuation?: any;
};

/** Строка таблиц / агрегатов «Активы» с оценкой в разных полях (WS / ATON / CRM). */
export type ActivesValuationItem = {
    account_name?: string;
    fio?: string;
    tmp_valuation?: number;
    valuation?: number;
    aggregated_valuation?: any;
    value?: any;
    attributes?: ActivesValuationAttributes;
    score_position_rub?: any;
    sum_valuation?: any;
};

export function getActivesItemValuation(item: ActivesValuationItem | null | undefined): number {
    if (!item) {
        return 0;
    }

    // `Number(null)` → 0: не глотать `value` из users_today_valuation, если aggregate пустой/нулевой.
    const aggregatedValuation = Number(item.aggregated_valuation);
    if (Number.isFinite(aggregatedValuation) && aggregatedValuation > 0) {
        return aggregatedValuation;
    }

    if (typeof item.tmp_valuation === "number" && item.tmp_valuation > 0) {
        return item.tmp_valuation;
    }

    const candidates: any[] = [
        item.value,
        item.valuation,
        item.attributes?.value,
        item.attributes?.valuation,
        item.attributes?.score_position_rub ?? item.score_position_rub,
        item.attributes?.sum_valuation ?? item.sum_valuation,
    ];

    for (const value of candidates) {
        const asNumber = Number(value);
        if (Number.isFinite(asNumber)) {
            return asNumber;
        }
    }

    return 0;
}

/** Для агрегации в ChartActives: только строго положительные поля. */
export function getActivesPositiveValuation(item: ActivesValuationItem | null | undefined): number {
    if (!item) {
        return 0;
    }

    const directValue = Number(item.value);
    if (Number.isFinite(directValue) && directValue > 0) {
        return directValue;
    }

    const directValuation = Number(item.valuation);
    if (Number.isFinite(directValuation) && directValuation > 0) {
        return directValuation;
    }

    const attributesValue = Number(item.attributes?.value);
    if (Number.isFinite(attributesValue) && attributesValue > 0) {
        return attributesValue;
    }

    const attributesValuation = Number(item.attributes?.valuation);
    if (Number.isFinite(attributesValuation) && attributesValuation > 0) {
        return attributesValuation;
    }

    const scorePositionRub = Number(item.attributes?.score_position_rub ?? item.score_position_rub);
    if (Number.isFinite(scorePositionRub) && scorePositionRub > 0) {
        return scorePositionRub;
    }

    const sumValuation = Number(item.attributes?.sum_valuation ?? item.sum_valuation);
    if (Number.isFinite(sumValuation) && sumValuation > 0) {
        return sumValuation;
    }

    return 0;
}

export function filterActivesItemsWithValuation<T extends ActivesValuationItem>(items: T[]): T[] {
    return items.filter((item) => getActivesItemValuation(item) > 0);
}

export function sortActivesItemsByValuationDesc<T extends ActivesValuationItem>(items: T[]): T[] {
    return [...items].sort(
        (a, b) => getActivesItemValuation(b) - getActivesItemValuation(a)
    );
}

export function sumActivesValuationExcludingTotalRow(
    items: ActivesValuationItem[],
    totalRowLabel = "Всего"
): number {
    return items.reduce((sum, item) => {
        if (item.fio === totalRowLabel) {
            return sum;
        }
        return sum + getActivesItemValuation(item);
    }, 0);
}
